// src/pages/Presence.js 
// (Assuming this file contains your Presence component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import PresenceMap from './PageComponent/PresenceMap';

function Presence() {

  // The useMeta hook call is removed and its content is moved into <Helmet>
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>PRESENCE | Marvel Blinds</title>
        <meta
          name="description"
          content="Discover how to enhance your presence and connect with others. Visit us for tips and strategies to boost your personal impact today.."
        />
        {/* Canonical URL is hardcoded as a string */}
        <link rel="canonical" href='https://callistusblinds.com/presence/' />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="PRESENCE" />
        <meta
          property="og:description"
          content="Discover how to enhance your presence and connect with others. Visit us for tips and strategies to boost your personal impact today."
        />
        <meta property="og:url" content='https://callistusblinds.com/presence/' />
        <meta property="og:site_name" content="Marvel Blinds" />
      </Helmet>

      {/* Rest of your component structure */}
      <div>
        <Navbar />
        <NotificationBar />
        <PresenceMap />
        <Footer />
      </div>
    </>
  );
}

export default Presence;